import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";

const UpdateAtmCardStatus = ({ onUpdateStatus, cardStatus }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    const validationSchema = Yup.object().shape({
        status: Yup.string().required("This field is required."),
    });

    const statusOptions = [
        { label: "Active", value: "001" },
        { label: "Inactive", value: "002" },
    ];

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            status: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                await onUpdateStatus(data.status);
                setloading(false);
                setloadingIcon("pi pi-save");
            } catch (error) {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    useEffect(() => {
        formik.setFieldValue("status", cardStatus);
    }, [cardStatus]);

    if (cardStatus === null) {
        return null;
    }

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1> Update ATM Card Status </h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="status" className={classNames({ "p-error": isFormFieldValid("status") }, "Label__Text")}>
                                ATM Card Status<span className="Label__Required">*</span>
                            </label>
                            <Dropdown id="status" placeholder="Select ATM Card Status" options={statusOptions} name="status" value={formik.values.status} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("status") }, "Dropdown__Round")} />
                            {getFormErrorMessage("status")}
                        </div>
                    </div>
                </div>

                <div className="Down__Btn">
                    <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={"Search"} className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
};

export default UpdateAtmCardStatus;
